import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { loginUserTokenAction } from "store/actions/token";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const authApi = createApi({
  reducerPath: REDUCER_PATHS.AUTH,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        headers: {
          deviceid: "web",
        },
        url: apiConfig.LOGIN,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then((res) => {
            let data = res?.data;
            if (data?.extraMeta) {
              dispatch(
                loginUserTokenAction({ data: data.data, ...data.extraMeta })
              );
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: apiConfig.LOGOUT,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: apiConfig.FORGOT_PW,
        body: data,
        method: "POST",
        headers: {
          technology: "react",
        },
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    resetPass: builder.mutation({
      query: (data) => ({
        url: apiConfig.RESET_PW,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    resetUserPass: builder.mutation({
      query: ({ token, password }) => ({
        url: `${apiConfig.RESET_USER_PW}?token=${encodeURIComponent(token)}`,
        body: { password },
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getTableColumnSettings: builder.query({
      query: () => ({
        url: apiConfig.GET_COLUMN_TABLE_SETTINGS,
        method: "GET",
      }),
    }),
    adminRegistration: builder.mutation({
      query: (data) => ({
        headers: {
          deviceid: "web",
          languageId: "English",
        },
        url: apiConfig.ADMIN_REGISTRATION + data.isRegisterType + "/register",
        body: {
          name: data.name,
          emailId: data.emailId,
          password: data.password,
          type: data.type,
          hotelGroup: data?.hotelGroup,
        },
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deleteUserAccount: builder.mutation({
      query: (data) => ({
        url: apiConfig.DELETE_USER_ACCOUNT,
        body: data,
        method: "POST",
      }),
      //transformResponse: (resp) => transformResponseHandler(resp),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useResetPassMutation,
  useResetUserPassMutation,
  useForgotPasswordMutation,
  useGetTableColumnSettingsQuery,
  useAdminRegistrationMutation,
  useDeleteUserAccountMutation,
} = authApi;

export default authApi;
